export default __webpack_public_path__ + "static/media/5.c3e3f3e8.png";